<template>
  <div
    id="spinner"
    :style="spinnerBackgroundStyle"
  >
    <div class="d-flex align-center justify-center full-width full-height">
      <v-progress-circular
        color="blue"
        indeterminate
        size="25"
      />
    </div>
    <button @click.prevent="loginWithFacebook">
      <div
        class="fb-login-button"
        :data-max-rows="maxRows"
        :data-size="size"
        :data-button-type="buttonType"
        :data-use-continue-as="useContinueAs"
        :data-width="dataWidth"
        style="pointer-events: none;"
      />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    spinnerBackgroundStyle: {
      type: Object,
      default: () => ({
        background: '#4267b2',
        borderRadius: '5px',
        color: 'white',
        height: '40px',
        width: '300px'
      })
    },
    maxRows: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: 'large',
      validator: (val) => {
        return ['large', 'medium', 'small'].includes(val)
      }
    },
    dataWidth: {
      type: String,
      default: '300'
    },
    buttonType: {
      type: String,
      default: 'continue_with',
      validator: (val) => {
        return ['continue_with', 'login_with'].includes(val)
      }
    },
    useContinueAs: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    sdkLocale () {
      return this.convertLocale(this.currentLocale, 'bcp47').replace('-', '_')
    }
  },
  created () {
    const elements = document.getElementsByTagName('script')
    elements.forEach(el => {
      if (el.src?.startsWith('https://connect.facebook.net/')) {
        el.remove()
      }
    })
    delete window.FB
    window.loginWithFacebook = this.loginWithFacebook
  },
  mounted () {
    this.initializeFacebookSDK()
  },
  methods: {
    initializeFacebookSDK () {
      window.fbAsyncInit = () => {
        window.FB.Event.subscribe('xfbml.render', this.finishedRendering)
        window.FB.init({
          appId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
          cookie: true,
          xfbml: true,
          version: process.env.VUE_APP_FACEBOOK_API_VERSION
        })
        window.FB.AppEvents.logPageView()
      }
      // Insert Facebook SDK if not found in header
      const id = 'facebook-jssdk'
      if (!document.getElementById(id)) {
        const fjs = document.getElementsByTagName('script')[0]
        const js = document.createElement('script')
        js.id = id
        if (process.env.NODE_ENV === 'development') {
          js.src = `https://connect.facebook.net/${this.sdkLocale}/sdk/debug.js`
        } else {
          js.src = `https://connect.facebook.net/${this.sdkLocale}/sdk.js`
        }
        fjs.parentNode.insertBefore(js, fjs)
      }
    },
    // Remove spinner while Facebook SDK had been initialized
    finishedRendering () {
      const spinner = document.getElementById('spinner')
      spinner.removeAttribute('style')
      spinner.removeChild(spinner.childNodes[0])
    },
    loginWithFacebook () {
      window.FB.login(response => {
        if (response.authResponse) {
          const obj = {
            social_media: 'FACEBOOK',
            user_id: response.authResponse.userID,
            access_token: response.authResponse.accessToken
          }
          this.$emit('login:success', obj)
        } else {
          this.$emit('login:cancel')
        }
      })
    },
    logout () {
      window.FB.logout(response => {
        // 
      })
    }
  }
}
</script>

<style scoped>
.full-height {
  height: 100%
}
</style>
